import React, { useState, useEffect } from 'react';
import { newsAPI } from '../../../../services/news.service';
import { libraryAPI } from '../../../../services/library.service';
import CategoryList from './CategoryList';
import CategoryModal from './CategoryModal';

const CategoryManager = ({ showMessage }) => {
  const [newsCategories, setNewsCategories] = useState([]);
  const [bookCategories, setBookCategories] = useState([]);
  const [modalType, setModalType] = useState(null); // 'newsCategory' or 'bookCategory'
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [newsResponse, booksResponse] = await Promise.all([
        newsAPI.getCategories(),
        libraryAPI.getCategories()
      ]);
      
      const newsData = newsResponse.data?.results || newsResponse.data || [];
      const booksData = booksResponse.data?.results || booksResponse.data || [];

      setNewsCategories(Array.isArray(newsData) ? newsData : []);
      setBookCategories(Array.isArray(booksData) ? booksData : []);
    } catch (error) {
      console.error('Error loading categories', error);
      if (showMessage) showMessage('Ошибка загрузки категорий', 'error');
    }
  };

  const handleCreate = async (formData) => {
    setLoading(true);
    try {
      if (modalType === 'newsCategory') {
        await newsAPI.createCategory(formData);
      } else {
        await libraryAPI.createCategory(formData);
      }
      if (showMessage) showMessage('Категория создана!');
      setModalType(null);
      loadData();
    } catch (error) {
      console.error('Error creating category', error);
      if (showMessage) showMessage('Ошибка при создании категории', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-content">
      <div className="content-header">
        <h2>Управление категориями</h2>
      </div>

      <div className="categories-section">
        <div className="category-type">
          <h3>Категории новостей</h3>
          <button className="action-button primary" onClick={() => setModalType('newsCategory')}>
            ➕ Добавить
          </button>
          <CategoryList categories={newsCategories} />
        </div>

        <div className="category-type">
          <h3>Категории книг</h3>
          <button className="action-button primary" onClick={() => setModalType('bookCategory')}>
            ➕ Добавить
          </button>
          <CategoryList categories={bookCategories} />
        </div>
      </div>

      <CategoryModal 
        type={modalType} 
        isOpen={!!modalType} 
        onClose={() => setModalType(null)} 
        onSubmit={handleCreate} 
        loading={loading}
      />
    </div>
  );
};

export default CategoryManager;
